import React, { VFC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { ThemePageCard } from '../pages/Top';
import {
  HomeMediaCard,
  HOME_MEDIA_DEFAULT_MEDIA_PADDING_TOP,
} from '../components/home/cards';

type Props = ThemePageCard & {
  className?: string;
};

const Card: VFC<Props> = ({
  headline,
  slug,
  cardImageUrl,
  headerImageUrl,
  className,
}) => {
  const classes = useStyles();
  const imageUrl = cardImageUrl || headerImageUrl;

  return (
    <HomeMediaCard
      href={`/theme/${slug}`}
      className={clsx(classes.root, className)}
      elevated
      imageUrl={imageUrl}
      imageAlt={headline}
      mediaAspectPaddingTop={HOME_MEDIA_DEFAULT_MEDIA_PADDING_TOP}
    >
      <p className={classes.title}>{headline}</p>
    </HomeMediaCard>
  );
};

export default Card;

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiCardActionArea-root:hover': {
      opacity: 0.8,
    },
  },
  title: {
    fontWeight: 'bold',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical' as const,
    fontSize: theme.typography.pxToRem(14),
    height: `calc(${theme.typography.pxToRem(14)} * ${
      theme.typography.body1.lineHeight
    } * 2)`,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(16),
      height: `calc(${theme.typography.pxToRem(16)} * ${
        theme.typography.body1.lineHeight
      } * 2)`,
    },
    margin: 0,
    marginTop: theme.spacing(1),
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
}));
